import React, { useEffect } from 'react';
import useServiceStatuses from '../../helpers/useServiceStatuses';
import RefreshIcon from '@mui/icons-material/Refresh';
import { IconButton } from '@mui/material';


// Punto verde o rojo según estado
const StateColor = ({ ok }) => (
  <span
    style={{
      display: 'inline-block',
      width: '7px',
      height: '7px',
      borderRadius: '50%',
      backgroundColor: ok ? 'green' : 'red',
    }}
  />
);

const MonitoringSystem = () => {
  const { statuses, checkAll } = useServiceStatuses();


  useEffect(() => {
    checkAll();
  }, [checkAll]);


  const groups = [
    {
      title: 'Azure',
      items: [
        { label: 'API-PRO', id: 'Azure-API Producción' },
        { label: 'AUTH-PRO', id: 'Azure-AUTH Producción' },
      ],
    },
    {
      title: 'Ionos',
      items: [
        { label: 'API-PRO', id: 'Ionos-API Producción' },
        { label: 'AUTH-PRO', id: 'Ionos-AUTH Producción' },
      ],
    },
    {
      title: 'Azure Desarrollo',
      items: [
        { label: 'API-DEV', id: 'Azure-API Desarrollo' },
        { label: 'AUTH-DEV', id: 'Azure-AUTH Desarrollo' },
      ],
    },
    {
      title: 'Mails',
      items: [
        { label: 'Azure', id: 'Azure-MAILS' },
        { label: 'Ionos', id: 'Ionos-MAILS' },
      ],
    },
    /*
    {
      title: 'SERVEO',
      items: [
        { label: 'API-PRO', id: 'Serveo-API Producción' },
        { label: 'AUTH-PRO', id: 'Serveo-AUTH Producción' },
      ],
    }
      */
  ];

  return (
    
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        gap: '10px',
        padding: '8px 10px',
        border: '1px solid #ccc',
        borderRadius: '10px',
        backgroundColor: '#fff',
        fontSize: '12px',
      }}
    >
      {groups.map((group, index) => (
        <div
          key={group.title}
          style={{
            display: 'flex',
            flexDirection: 'column',
            minWidth: '150px',
            borderRight: index < groups.length - 1 ? '1px solid #ddd' : 'none',
            paddingRight: '12px',
          }}
        >
          <strong style={{ marginBottom: '6px', color: '#374151' }}>{group.title}:</strong>
          {group.items.map(({ label, id }) => (
            <div
              key={id}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '6px',
              }}
            >
              <span>{label}</span>
              <StateColor ok={statuses[id]} />
            </div>
          ))}
        </div>
      ))}

      <div style={{ marginLeft: 'auto' }}>
        <IconButton
          onClick={checkAll}
          size="small"
          title="Recargar"
        >
          <RefreshIcon fontSize="small" />
        </IconButton>

      </div>
    </div>
  );
};

export default MonitoringSystem;
